export const PagesPaths = {
  SIGNIN: { name: 'SIGNIN', path: '/connexion' },
  SIGNUP: { name: 'SIGNUP', path: '/inscription' },
  GARDENERS: { name: 'GARDENERS', path: '/jardiniers' },
  GARDENER: { name: 'GARDENER', path: '/jardinier' },
  INQUIRY: { name: 'INQUIRY', path: '/demande' },
  ACCOUNT: { name: 'ACCOUNT', path: '/compte' },
  ACCOUNT_EDIT: { name: 'ACCOUNT_EDIT', path: '/compte/edition' },
  AVANCE_IMMEDIATE: { name: 'AVANCE_IMMEDIATE', path: '/compte/avance-immediate' },
  INQUIRY_SUBMIT: { name: 'INQUIRY_SUBMIT', path: '/demande/submit' },
  INQUIRY_CREATED: { name: 'INQUIRY_CREATED', path: '/demande/created' },
  INQUIRIES: { name: 'INQUIRIES', path: '/demandes' },
  INQUIRY_VISIT_DETAIL: { name: 'INQUIRY_VISIT_DETAIL', path: '/demande/visits' },
  INQUIRY_MAINTENANCE_DETAIL: { name: 'INQUIRY_MAINTENANCE_DETAIL', path: '/demande/maintenances' },
  INQUIRY_REALISATION_DETAIL: { name: 'INQUIRY_REALISATION_DETAIL', path: '/demande/realisations' },
  CONNECT_AS: { name: 'CONNECT_AS', path: '/logged_as' },
  RESET_PASSWORD: { name: 'RESET_PASSWORD', path: '/reset-password' },
  GARDENER_DISPONIBILITY_MGMT: { name: 'GARDENER_DISPONIBILITY_MGMT', path: '/disponibilite/jardinier' },
  PAYMENT_STATUS: { name: 'PAYMENT_STATUS', path: '/paiement/statut' }
}

export const Pages = Object.values(PagesPaths).map((p, i) => {
  return { name: p.name, page: p.path.split('/')[1] }
})



// WEBPACK FOOTER //
// ./src/constants/Pages.js